import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-addStop",
  "use": "icon-addStop-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-addStop\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\" /><g><circle cx=\"8\" cy=\"8\" r=\"7.25\" stroke=\"currentColor\" stroke-width=\"1.5\" /><g fill=\"currentColor\"><path d=\"M5 7.25h6v1.5H5z\" /><path d=\"M8.75 5v6h-1.5V5z\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol